<template>
  <div>
    <div v-if="deviceData && deviceData.id" class="breadcrumb-area pos-relative w-100">
      <div class="mb-3 row">
        <h1 class="col-sm-3" style="min-width: fit-content">Chi tiết KPI</h1>
        <div class="col-sm-9 d-flex justify-content-end">
          <!-- NEW -->
          <template v-if="deviceData.status === 'NEW'">
            <b-button
              class="ml-2"
              variant="danger"
              v-if="canDeviceKpiCancelMx()"
              @click="deviceKpiCancel([deviceData.id])"
              >Hủy</b-button
            >
            <b-button
              class="ml-2"
              variant="success"
              v-if="canDeviceKpiUpdateMx()"
              @click="changeDevices(deviceData, deviceData.serviceType)"
              >Sửa</b-button
            >
            <b-button
              v-if="canDeviceKpiSendApproveMx()"
              @click="deviceKpiSendApproveMx([deviceData.id])"
              class="ml-2"
              variant="primary"
              >Gửi duyệt</b-button
            >
          </template>
          <!-- WAIT_ACCOUNTANT_APPROVE -->
          <template v-if="deviceData.status === 'WAIT_ACCOUNTANT_APPROVE'">
            <b-button
              v-if="canDeviceKpiAccountantApproveMx()"
              @click="showModalAccountantApprove = true"
              class="ml-2"
              variant="primary"
              >Kế toán xác nhận</b-button
            >
            <b-button
              v-if="canDeviceKpiAccountantRejectMx()"
              @click="deviceKpiAccountantRejectMx([deviceData.id])"
              class="ml-2"
              variant="danger"
              >Kế toán từ chối</b-button
            >
            <b-button
              v-if="canDeviceKpiAccountantAdditionalMx()"
              @click="deviceKpiAccountantAdditionalMx([deviceData.id])"
              class="ml-2"
              variant="info"
              >Cần bổ sung</b-button
            >
          </template>

          <!-- ADDITIONAL -->
          <template v-if="deviceData.status === 'ADDITIONAL'">
            <b-button
              class="ml-2"
              variant="info"
              v-if="canDeviceKpiSAAdditionalMx()"
              @click="showModalAdminAddtional = true"
              >Admin bổ sung</b-button
            >
            <b-button
              class="ml-2"
              variant="danger"
              v-if="canDeviceKpiCancelMx()"
              @click="deviceKpiCancel([deviceData.id])"
              >Hủy</b-button
            >
          </template>

          <!-- WAIT_MONITOR_APPROVE -->
          <template v-if="deviceData.status === 'WAIT_MONITOR_APPROVE'">
            <b-button
              class="ml-2"
              variant="primary"
              v-if="canDeviceKpiMonitorApproveMx()"
              @click="deviceKpiMonitorApproveMx([deviceData.id])"
              >GS xác nhận</b-button
            >
            <b-button
              class="ml-2"
              variant="danger"
              v-if="canDeviceKpiMonitorRejectMx()"
              @click="deviceKpiMonitorRejectMx([deviceData.id])"
              >GS từ chối</b-button
            >
            <b-button
              class="ml-2"
              variant="info"
              v-if="canDeviceKpiMonitorRequestExplanationMx()"
              @click="deviceKpiMonitorRequestExplanationMx([deviceData.id])"
              >Cần giải trình</b-button
            >
          </template>

          <!-- EXPLANATION -->
          <template v-if="deviceData.status === 'EXPLANATION'">
            <b-button
              class="ml-2"
              variant="info"
              v-if="canDeviceKpiSAExplanationMx()"
              @click="showModalSAExplanation = true"
              >Admin giải trình</b-button
            >
            <b-button
              class="ml-2"
              variant="danger"
              v-if="canDeviceKpiCancelMx()"
              @click="deviceKpiCancel([deviceData.id])"
              >Hủy</b-button
            >
          </template>

          <b-button class="ml-2" variant="" @click="goBackList">Quay lại</b-button>
        </div>
      </div>
      <div class="row mb-3">
        <div class="col-sm-6">
          <div class="form-detail">
            <h1 class="w-100">Thông tin tính KPI</h1>
            <div class="form-group form-row">
              <label class="col-sm-4 col-form-label">Tên<span class="float-right">:</span></label>
              <div class="col-sm-8">
                <p class="form-control-plaintext f12">{{ deviceData.categoryName }}</p>
              </div>
            </div>
            <div class="form-group form-row">
              <label class="col-sm-4 col-form-label"
                >Serial<span class="float-right">:</span></label
              >
              <div class="col-sm-8">
                <p class="form-control-plaintext f12">{{ deviceData.serial }}</p>
              </div>
            </div>
            <div class="form-group form-row">
              <label class="col-sm-4 col-form-label"
                >Số tiền<span class="float-right">:</span></label
              >
              <div class="col-sm-8">
                <p class="form-control-plaintext f12">{{ deviceData.price | transformMoney }}</p>
              </div>
            </div>
            <div class="form-group form-row">
              <label class="col-sm-4 col-form-label">KPI<span class="float-right">:</span></label>
              <div class="col-sm-8">
                <p class="form-control-plaintext f12">{{ deviceData.kpi }}</p>
              </div>
            </div>
            <div class="form-group form-row">
              <label class="col-sm-4 col-form-label"
                >Tháng tính<span class="float-right">:</span></label
              >
              <div class="col-sm-8">
                <p class="form-control-plaintext f12">{{ deviceData.month }}</p>
              </div>
            </div>
            <div class="form-group form-row">
              <label class="col-sm-4 col-form-label"
                >CVKD được ghi nhận<span class="float-right">:</span></label
              >
              <div class="col-sm-8">
                <p class="form-control-plaintext f12">
                  {{ deviceData.nameSale + ' - ' + deviceData.emailSale }}
                </p>
              </div>
            </div>
            <div class="form-group form-row">
              <label class="col-sm-4 col-form-label"
                >Người tạo KPI<span class="float-right">:</span></label
              >
              <div class="col-sm-8">
                <p class="form-control-plaintext f12" v-if="deviceData.creator">
                  {{ deviceData.creator.name + ' - ' + deviceData.creator.email }}
                </p>
              </div>
            </div>
            <div class="form-group form-row">
              <label class="col-sm-4 col-form-label"
                >Quản lý TT<span class="float-right">:</span></label
              >
              <div class="col-sm-8">
                <p class="form-control-plaintext f12">
                  {{ deviceData.superiorName + ' - ' + deviceData.superior }}
                </p>
              </div>
            </div>
            <div class="form-group form-row">
              <label class="col-sm-4 col-form-label"
                >Kế toán xác nhận thu tiền<span class="float-right">:</span></label
              >
              <div class="col-sm-8">
                <p class="form-control-plaintext f12">
                  {{ deviceData.statusPayment | transformData(Config.statusPaymentOptions) }}
                </p>
              </div>
            </div>
            <div class="form-group form-row">
              <label class="col-sm-4 col-form-label"
                >Tình trạng file hợp đồng<span class="float-right">:</span></label
              >
              <div class="col-sm-8">
                <p class="form-control-plaintext f12">
                  {{
                    deviceData.statusFileContract | transformData(Config.statusFileContractOptions)
                  }}
                </p>
              </div>
            </div>
            <div class="form-group form-row">
              <label class="col-sm-4 col-form-label"
                >Trạng thái phiếu thu<span class="float-right">:</span></label
              >
              <div class="col-sm-8">
                <p class="form-control-plaintext f12">
                  <span class="badge" :class="deviceData.receiptStatus">
                    {{ deviceData.receiptStatus | transformData(Config.stateReceipt) }}
                  </span>
                </p>
              </div>
            </div>
            <div class="form-group form-row">
              <label class="col-sm-4 col-form-label"
                >Trạng thái phụ lục<span class="float-right">:</span></label
              >
              <div class="col-sm-8">
                <p class="form-control-plaintext f12">
                  <span class="badge" :class="deviceData.appendixStatus">
                    {{ deviceData.appendixStatus | transformData(Config.listStatusContract) }}
                  </span>
                </p>
              </div>
            </div>
            <div class="form-group form-row">
              <label class="col-sm-4 col-form-label"
                >Trạng thái bàn giao<span class="float-right">:</span></label
              >
              <div class="col-sm-8">
                <p class="form-control-plaintext f12">
                  <span class="badge" :class="deviceData.statusHandover">
                    {{ deviceData.statusHandover | transformData(Config.statusHandoverList) }}
                  </span>
                </p>
              </div>
            </div>
            <div class="form-group form-row">
              <label class="col-sm-4 col-form-label"
                >Trạng thái KPI<span class="float-right">:</span></label
              >
              <div class="col-sm-8">
                <p class="form-control-plaintext f12">
                  <span class="badge" :class="deviceData.status">
                    {{ deviceData.status | transformData(Config.statusDeviceKpi) }}
                  </span>
                </p>
              </div>
            </div>
            <div class="form-group form-row" v-if="deviceData.packageType">
              <label class="col-sm-4 col-form-label"
                >Loại gói<span class="float-right">:</span></label
              >
              <div class="col-sm-8">
                <p class="form-control-plaintext f12">{{ deviceData.packageType }}</p>
              </div>
            </div>
            <div class="form-group form-row" v-if="deviceData.duration">
              <label class="col-sm-4 col-form-label"
                >Thời hạn<span class="float-right">:</span></label
              >
              <div class="col-sm-8">
                <p class="form-control-plaintext f12">{{ deviceData.duration }}</p>
              </div>
            </div>
            <div class="form-group form-row">
              <label class="col-sm-4 col-form-label"
                >Ghi chú<span class="float-right">:</span></label
              >
              <div class="col-sm-8">
                <p class="form-control-plaintext f12">{{ deviceData.note }}</p>
              </div>
            </div>
          </div>
          <div class="form-detail">
            <h1 class="w-100">Thông tin phiếu thu</h1>
            <div class="form-group form-row">
              <label class="col-sm-4 col-form-label"
                >Mã phiếu thu<span class="float-right">:</span></label
              >
              <div class="col-sm-8">
                <p class="form-control-plaintext f12">{{ deviceData.receiptCode }}</p>
              </div>
            </div>
            <div class="form-group form-row">
              <label class="col-sm-4 col-form-label"
                >Mã giao dịch<span class="float-right">:</span></label
              >
              <div class="col-sm-8">
                <p class="form-control-plaintext f12">{{ deviceData.transactionCode }}</p>
              </div>
            </div>
            <div class="form-group form-row" v-if="deviceData.receiptTime">
              <label class="col-sm-4 col-form-label"
                >Ngày thu tiền<span class="float-right">:</span></label
              >
              <div class="col-sm-8">
                <p class="form-control-plaintext f12">{{ deviceData.receiptTime | formatDate }}</p>
              </div>
            </div>
            <div class="form-group form-row" v-if="!deviceData.receiptTime && deviceData.payTime">
              <label class="col-sm-4 col-form-label"
                >Ngày thanh toán<span class="float-right">:</span></label
              >
              <div class="col-sm-8">
                <p class="form-control-plaintext f12">{{ ddeviceData.payTime | formatDate }}</p>
              </div>
            </div>
            <div class="form-group form-row">
              <label class="col-sm-4 col-form-label"
                >Hình thức thu tiền<span class="float-right">:</span></label
              >
              <div class="col-sm-8">
                <p class="form-control-plaintext f12">
                  {{ deviceData.paymentType | mapTextStatus(Config.typePayment) }}
                </p>
              </div>
            </div>
          </div>
          <div class="form-detail">
            <h1 class="w-100">Lịch sử ghi nhận KPI</h1>
            <b-table
              responsive
              hover
              :items="historyData"
              :fields="fieldsTable"
              :fixed="true"
              :bordered="true"
            >
              <template #cell(creator)="data">
                <div>
                  {{ data.item.creator ? data.item.creator.name : '' }}
                </div>
                <div>
                  {{ data.item.creator ? data.item.creator.username : '' }}
                </div>
              </template>
              <template #cell(type)="data">
                <div>
                  {{ data.item.type | transformData(Config.logsDeviceKpi) }}
                </div>
              </template>
              <template #cell(createdTime)="data">
                <div>
                  {{ data.item.createdTime | formatDate('DD/MM/YYYY HH:mm:ss') }}
                </div>
              </template>
            </b-table>
          </div>
        </div>
        <div class="col-sm-6">
          <div class="form-detail">
            <h1 class="w-100">Thông tin hợp đồng</h1>
            <div class="form-group form-row">
              <label class="col-sm-4 col-form-label"
                >Tên merchant<span class="float-right">:</span></label
              >
              <div class="col-sm-8">
                <p class="form-control-plaintext f12">{{ deviceData.merchantName }}</p>
              </div>
            </div>
            <div class="form-group form-row">
              <label class="col-sm-4 col-form-label"
                >Email MC<span class="float-right">:</span></label
              >
              <div class="col-sm-8">
                <p class="form-control-plaintext f12">{{ deviceData.merchantEmail }}</p>
              </div>
            </div>
            <div class="form-group form-row">
              <label class="col-sm-4 col-form-label">SĐT<span class="float-right">:</span></label>
              <div class="col-sm-8">
                <p class="form-control-plaintext f12">{{ deviceData.merchantMobile }}</p>
              </div>
            </div>
            <div class="form-group form-row">
              <label class="col-sm-4 col-form-label"
                >Địa chỉ<span class="float-right">:</span></label
              >
              <div class="col-sm-8">
                <p class="form-control-plaintext f12">{{ deviceData.merchantAddress }}</p>
              </div>
            </div>
            <div class="form-group form-row">
              <label class="col-sm-4 col-form-label"
                >Mã hợp đồng<span class="float-right">:</span></label
              >
              <div class="col-sm-8">
                <p class="form-control-plaintext f12">{{ deviceData.contractCode }}</p>
              </div>
            </div>
            <div class="form-group form-row">
              <label class="col-sm-4 col-form-label"
                >Mã phụ lục<span class="float-right">:</span></label
              >
              <div class="col-sm-8">
                <p class="form-control-plaintext f12">
                  {{ deviceData.appendixCode }} /
                  {{ deviceData.typeContract ? deviceData.typeContract : '' }}
                </p>
              </div>
            </div>
            <div class="form-group form-row">
              <label class="col-sm-4 col-form-label"
                >Ngày ký<span class="float-right">:</span></label
              >
              <div class="col-sm-8">
                <p class="form-control-plaintext f12">{{ deviceData.timeSign | formatDate }}</p>
              </div>
            </div>
            <div class="form-group form-row">
              <label class="col-sm-4 col-form-label"
                >Loại hợp đồng<span class="float-right">:</span></label
              >
              <div class="col-sm-8">
                <p class="form-control-plaintext f12">
                  {{ deviceData.formContract | transformData(Config.formContract) }}
                </p>
              </div>
            </div>
            <div class="form-group form-row">
              <label class="col-sm-4 col-form-label"
                >Nguồn MC<span class="float-right">:</span></label
              >
              <div class="col-sm-8">
                <p class="form-control-plaintext f12">
                  {{ deviceData.referSource | transformData(Config.sourceCreate) }}
                </p>
              </div>
            </div>
            <div class="form-group form-row">
              <label class="col-sm-4 col-form-label"
                >Loại MC<span class="float-right">:</span></label
              >
              <div class="col-sm-8">
                <p class="form-control-plaintext f12">{{ deviceData.merchantType }}</p>
              </div>
            </div>
            <div class="form-group form-row">
              <label class="col-sm-4 col-form-label"
                >Tình trạng<span class="float-right">:</span></label
              >
              <div class="col-sm-8">
                <p class="form-control-plaintext f12">
                  {{ deviceData.isMcLock ? 'Bị khóa' : 'Hoạt động' }}
                </p>
              </div>
            </div>
            <div class="form-group form-row">
              <label class="col-sm-4 col-form-label"
                >Phụ lục phí<span class="float-right">:</span></label
              >
              <div class="col-sm-8">
                <p class="form-control-plaintext f12">
                  {{ deviceData.isDiscountFee ? 'Ưu đãi' : 'Không ưu đãi' }}
                </p>
              </div>
            </div>
            <div class="form-group form-row">
              <label class="col-sm-4 col-form-label"
                >TB mua trong kỳ/Tổng TB<span class="float-right">:</span></label
              >
              <div class="col-sm-8">
                <p class="form-control-plaintext f12">
                  {{ deviceData.ratio ? deviceData.ratio : '' }}
                </p>
              </div>
            </div>
          </div>
          <div class="form-detail">
            <h1 class="w-100">Thông tin thiết bị của MC</h1>
            <div>
              <b-table
                :busy.sync="tbLoading"
                sticky-header
                responsive
                hover
                :items="deviceInfo"
                :fields="fieldsDeviceInfo"
                :fixed="true"
                :bordered="true"
                show-empty
                empty-text="Không có dữ liệu!"
              >
                <template #cell(index)="data">
                  <p :class="data.item.isKpi ? 'bold-green' : ''">{{ data.item.index }}</p>
                </template>
                <template #cell(nickname)="data">
                  <p :class="data.item.isKpi ? 'bold-green' : ''">{{ data.item.nickname }}</p>
                </template>
                <template #cell(serial)="data">
                  <p :class="data.item.isKpi ? 'bold-green' : ''">{{ data.item.serial }}</p>
                </template>
                <template #cell(contractCode)="data">
                  <p :class="data.item.isKpi ? 'bold-green' : ''">{{ data.item.contractCode }}</p>
                </template>
                <template #cell(receiptCode)="data">
                  <p :class="data.item.isKpi ? 'bold-green' : ''">{{ data.item.receiptCode }}</p>
                </template>
                <template #cell(timeExport)="data">
                  <p :class="data.item.isKpi ? 'bold-green' : ''">
                    {{ data.item.timeExport | formatDate('DD/MM/YYYY HH:mm:ss') }}
                  </p>
                </template>
              </b-table>
            </div>
          </div>
        </div>
      </div>
    </div>
    <ModalSAExplanation
      v-model="showModalSAExplanation"
      :dataEdit="deviceData"
      @submit="submitSAExplanation"
      :deviceKpiLogs="historyData"
    ></ModalSAExplanation>
    <ModalEditDevice
      v-model="showModalDevice"
      @submit="submitFormDevice"
      :dataEdit="deviceData"
      :serviceType="serviceType"
    ></ModalEditDevice>
    <ModalAdminAddtional
      v-model="showModalAdminAddtional"
      @submit="onAdminAddtional"
      :dataEdit="deviceData"
      :deviceKpiLogs="historyData"
    ></ModalAdminAddtional>
    <ModalAccountantApprove
      v-model="showModalAccountantApprove"
      @submit="onAccountantApprove"
    ></ModalAccountantApprove>
    <VueLoadingOverlay :active.sync="showLoading" :is-full-page="true"> </VueLoadingOverlay>
  </div>
</template>

<script>
  // import { StaffService } from '@/services/staff.service'
  import { DeviceService } from '@/services/device.service'
  import Config from '@/thirdParty/config'
  // import moment from 'moment'
  import kpiRecordMx from './kpiRecordMx'
  import ModalAccountantApprove from './components/ModalAccountantApprove.vue'
  import ModalAdminAddtional from './components/ModalAdminAddtional.vue'
  import ModalSAExplanation from './components/ModalSAExplanation.vue'

  const fieldsDeviceInfo = [
    { key: 'index', label: 'STT', class: 'text-center' },
    { key: 'nickname', label: 'Tên TB', thStyle: '' },
    { key: 'serial', label: 'Mã Serial', thStyle: 'min-width: 220px' },
    { key: 'contractCode', label: 'Mã HĐ/PL', thStyle: '' },
    { key: 'receiptCode', label: 'Mã phiếu thu', thStyle: '' },
    { key: 'timeExport', label: 'Ngày xuất', thStyle: '' },
  ]

  export default {
    components: {
      ModalAccountantApprove,
      ModalAdminAddtional,
      ModalSAExplanation,
    },
    mixins: [kpiRecordMx],

    data() {
      return {
        Config,
        showLoading: false,
        deviceData: null,
        name: '123',
        fieldsTable: [
          { key: 'type', label: 'Loại', thStyle: '' },
          { key: 'creator', label: 'Người thực hiện', thStyle: '' },
          { key: 'createdTime', label: 'Thời gian', thStyle: '' },
          { key: 'note', label: 'Ghi chú', thStyle: '' },
        ],
        historyData: null,
        showModalAccountantApprove: false,
        showModalAdminAddtional: false,
        showModalSAExplanation: false,

        // ModalEditDevice
        serviceType: '',
        showModalDevice: false,
        deviceInfo: [],
        fieldsDeviceInfo: fieldsDeviceInfo,
      }
    },
    async created() {
      await this.fetchData()
      await this.deviceOrderExportGetDeviceMc()
    },
    methods: {
      goBackList() {
        this.$router.push({ name: 'kpi record upload history' })
      },
      async fetchData() {
        this.deviceData = null
        this.historyData = null
        this.deviceKpiGetLogs()
        try {
          this.showLoading = true
          const params = {
            id: this.$route.params.id,
          }
          const response = await DeviceService.deviceKpiDetail(params)
          if (response.code === 1000) {
            this.deviceData = response.data
            this.deviceData.kpi = String(response.data.kpi)
          } else {
            throw new Error(response.message)
          }
        } catch (error) {
          console.log(error)
          this.showFailMx(error.message ?? error)
        } finally {
          this.showLoading = false
        }
      },
      async deviceKpiGetLogs() {
        try {
          this.showLoading = true
          const params = {
            id: this.$route.params.id,
          }
          const response = await DeviceService.deviceKpiGetLogs(params)
          if (response.code === 1000) {
            this.historyData = response.data
          } else {
            throw new Error(response.message)
          }
        } catch (error) {
          console.log(error)
          this.showFailMx(error.message ?? error)
        } finally {
          this.showLoading = false
        }
      },

      async onAccountantApprove(data) {
        const isDone = await this.deviceKpiAccountantApproveMx({
          ...data,
          ids: [this.$route.params.id],
        })
        if (isDone) {
          this.showModalAccountantApprove = false
          await this.$nextTick()
          this.showSuccessMx('Kế toán xác nhận thành công')
        }
      },
      async submitSAExplanation(data) {
        const isDone = await this.deviceKpiSAExplanationMx({
          ...data,
          ids: [this.$route.params.id],
        })
        if (isDone) {
          this.showModalSAExplanation = false
          await this.$nextTick()
          this.showSuccessMx('SA giải trình thành công')
        }
      },

      changeDevices(device, serviceType) {
        console.log({ device, serviceType })
        if (!device || !serviceType) {
          this.showFailMx('Không có đủ thông tin thiết bi')
          return
        }
        this.serviceType = serviceType
        this.showModalDevice = true
      },
      async submitFormDevice({ data, serviceType }) {
        const params = { ...data, serviceType }
        const isDone = await this.deviceKpiUpdateMx(params)
        if (isDone) {
          this.showModalDevice = false
          await this.$nextTick()
          this.showSuccessMx('Đã cập nhập thiết bị thành công')
        }
      },

      async onAdminAddtional(data) {
        const isDone = await this.deviceKpiSAAdditionalMx({
          ...data,
          id: this.$route.params.id,
        })
        if (isDone) {
          this.showModalAdminAddtional = false
        }
      },
      async deviceKpiCancel(ids) {
        await this.deviceKpiCancelMx(ids)
      },
      async deviceOrderExportGetDeviceMc() {
        this.deviceInfo = []
        try {
          const params = {
            mcId: this.deviceData.merchantId,
            month: this.deviceData.month,
          }
          const response = await DeviceService.deviceOrderExportGetDeviceMc(params)
          if (response.code === 1000) {
            this.deviceInfo = response.data.devices
          } else {
            throw new Error(response.message)
          }
        } catch (error) {
          console.log(error)
          this.showFailMx(error.message ?? error)
        } finally {
          this.showLoading = false
        }
      },
    },
  }
</script>

<style lang="scss" scoped>
  @import './commonStyles.css';

  .box-content {
    width: 100%;
    border: 1px solid #ddd;
    padding: 10px;
  }
  .row-item {
    margin: 10px 0;
  }
  .bold-green {
    color: green;
  }
</style>
